export default "__VITE_ASSET__Bvr8VJ5j__"